<template>
    <div>

    </div>
</template>
<script>
//Specific to Nest, even if support others in the future
    import axios from "axios";

    export default {
        name: 'ThermNestRegister',
        mounted() {
            var code = this.$route.query.code;
            
            if (code === undefined) {
                this.$router.push("Thermostat");
                return;
            }

            //I lack base here, so putting the logic in.
            
            axios ({
                method: "POST",
                url: this.$httpAxiosBaseUrl() + "thermostat/SaveAuthenticationToken",
                data: {
                    code,
                    "typeID": this.$thermostatTypes.Nest
                }
            }).then(result => {
                if (result !== null && result !== undefined) {
                    var itm = parseInt(result.data, 32);
                    //something bad happened.  Show the error message, then we'll just load things as normal.
                    if (isNaN(itm)) {
                        //even after redirect, it will show this.
                        this.$toasted.global.error(result.data);
                        this.$announcer.set(result.data);
                        this.$store.commit('setLastThermostatID', -1);
                    }
                    //We'll set the current thermostatID to the ID returned, which will be read by the thermostat.
                    else {
                        this.$store.commit('setLastThermostatID', itm);
                    }
                    this.$router.push("Thermostat");
                }
            });
        }
    }
</script>